import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import { useState, Fragment } from "react";
import PersonIcon from "@mui/icons-material/Person";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import EventIcon from "@mui/icons-material/Event";
import ConfirmDialog from "./Confirm";

const UserDetails = ({ formikProps }) => {
  const [confirm, setConfirm] = useState(false);
  const { userDetails } = formikProps.values;

  const renderInfo = (Icon, label, value) => (
    <Box display="flex" alignItems="center" mb={2}>
      <Box
        mr={2}
        display="flex"
        alignItems="center"
        justifyContent="center"
        bgcolor="#f3e8ff"
        borderRadius={2}
        p={1}
      >
        <Icon style={{ color: "#7c3aed" }} />
      </Box>
      <Box>
        <Typography variant="body2" color="text.secondary">
          {label}
        </Typography>
        <Typography variant="body1" fontWeight="bold">
          {value}
        </Typography>
      </Box>
    </Box>
  );

  return (
    <Fragment>
      <Grid container justifyContent="center" mt={4}>
        <Grid item xs={12} md={6} lg={4}>
          <Card
            elevation={3}
            sx={{
              borderRadius: 3,
              boxShadow:
                "rgb(50 50 93 / 47%) 0px 2px 5px -1px, rgba(0, 0, 0, 0.05) 0px 1px 3px -1px",
            }}
          >
            <Box display="flex" justifyContent="center" mt={3}>
              <Avatar
                sx={{ bgcolor: "#7c3aed", width: 64, height: 64, fontSize: 24 }}
              >
                {userDetails?.visitor_info?.first_name?.[0]}
                {userDetails?.visitor_info?.last_name?.[0]}
              </Avatar>
            </Box>
            {/* <Typography variant="h6" align="center" mt={2}>
              Permission Request
            </Typography>
            <Typography
              variant="body2"
              align="center"
              color="text.secondary"
              mb={3}
            >
              Allow access to your information for booking confirmation
            </Typography> */}

            <CardContent>
              <Typography variant="subtitle2" mb={2} color="primary">
                Shared Information
              </Typography>

              {renderInfo(
                PersonIcon,
                "Name",
                `${userDetails?.visitor_info?.first_name} ${userDetails?.visitor_info?.last_name}`
              )}
              {renderInfo(
                PhoneIcon,
                "Phone Number",
                userDetails?.visitor_info?.mobile_number ||
                  userDetails?.visitor_info?.phone_number
              )}
              {renderInfo(
                EmailIcon,
                "Email ID",
                userDetails?.visitor_info?.email_id
              )}
              {renderInfo(
                EventIcon,
                "Booking ID",
                userDetails?.employee_id || userDetails?.student_id
              )}
            </CardContent>

            <Grid container spacing={2} justifyContent="center" pb={3}>
              <Grid item xs={5}>
                <Button
                  variant="outlined"
                  color="error"
                  fullWidth
                  sx={{ padding: "10px" }}
                  onClick={() => {
                    setConfirm(true);
                    formikProps.setValues((prev) => ({
                      ...prev,
                      isAllowed: false,
                    }));
                  }}
                >
                  Decline
                </Button>
              </Grid>
              <Grid item xs={5}>
                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    background: "linear-gradient(to right, #7c3aed, #4f46e5)",
                  }}
                  onClick={() => {
                    formikProps.setValues((prev) => ({
                      ...prev,
                      isAllowed: true,
                    }));
                    formikProps.handleSubmit();
                  }}
                >
                  Allow
                </Button>
              </Grid>
            </Grid>
          </Card>
        </Grid>
      </Grid>

      <ConfirmDialog
        confirm={confirm}
        setConfirm={setConfirm}
        formikProps={formikProps}
      />
    </Fragment>
  );
};

export default UserDetails;
